import { createAsyncThunk } from "@reduxjs/toolkit";
import * as API from "./api";
import { getStockByIdAndBranch } from "../../../../../Stock/StockAnalysis/Redux/api";

// get saleInvoiceBranch
export const getSaleInvoiceBranch = createAsyncThunk(
  "saleInvoiceBranch/getSaleInvoiceBranch",
  async (params, { rejectWithValue }) => {
    const { rowsPerPage, search, sortOrder, pageNo } = params;
    try {
      const { data } = await API.getSaleInvoiceBranch({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// get all saleInvoiceBranch
export const getAllSaleInvoiceBranch = createAsyncThunk(
  "saleInvoiceBranch/getAllSaleInvoiceBranch",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await API.getAllSaleInvoiceBranch();
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// get previous
export const getPrevious = createAsyncThunk("saleInvoiceBranch/getPrevious", async (previous, { rejectWithValue }) => {
  try {
    const { data } = await API.getPrevious(previous);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
// get next
export const getNext = createAsyncThunk("saleInvoiceBranch/getNext", async (next, { rejectWithValue }) => {
  try {
    const { data } = await API.getNext(next);

    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get particular page
export const getParticularPage = createAsyncThunk(
  "saleInvoiceBranch/getParticularPage",
  async (params, { rejectWithValue }) => {
    const { number, rowsPerPage, search } = params;
    try {
      const { data } = await API.getPageSaleInvoiceBranch({ number, rowsPerPage: rowsPerPage, search });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);
// get item by id
export const getSaleInvoiceBranchById = createAsyncThunk(
  "saleInvoiceBranch/getSaleInvoiceBranchById",
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await API.getSaleInvoiceBranchById(id);
      if (data?.data.saleOrderDetails?.length > 0) {
        // get stock by id and branch
        const updatedDetailsPromises = data.data?.saleOrderDetails.map(async (detail) => {
          const { data: stockData } = await getStockByIdAndBranch(detail?.product?.id, data?.data.branch?.id);

          if (stockData.data?.length > 0) {
            return {
              ...detail,
              // availableStock stock from stockData
              availableStock: stockData.data[0]?.closingStock || "",
            };
          } else {
            return {
              ...detail,
              availableStock: 0,
            };
          }
        });

        const updatedDetails = await Promise.all(updatedDetailsPromises);
        return { ...data, data: { ...data.data, saleOrderDetails: updatedDetails } };
      } else {
        return data;
      }
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);
// get item by id
export const getSaleOrderDetail = createAsyncThunk(
  "saleInvoiceBranch/getSaleOrderDetail",
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await API.getSaleOrderDetail(id);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// create saleInvoiceBranch
export const createSaleInvoiceBranch = createAsyncThunk(
  "saleInvoiceBranch/createSaleInvoiceBranch",
  async (createData, { rejectWithValue }) => {
    const { branch, voucherDateBs, voucherDate, saleInvoiceDetails, salesOrderMain, discountAmount, grandTotal } =
      createData;
    try {
      const body = JSON.stringify({
        branch,
        voucherDateBs,
        voucherDate,
        saleInvoiceDetails,
        salesOrderMain,
        discountAmount,
        grandTotal,
        // termOfPayment, // removed
      });
      const { data } = await API.createSaleInvoiceBranch(body);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);
export const updateSaleInvoiceBranch = createAsyncThunk(
  "saleInvoiceBranch/updateSaleInvoiceBranch",
  async (data, { rejectWithValue }) => {
    const { id, values } = data;
    const {
      salesOrder,
      indentNo,
      isFromHo,
      requiredDateAd,
      voucherDateBs,
      voucherDate,
      branch,
      status,
      documentsAttach,
      discountAmount,
      grandTotal,
      // refVoucher,
      saleInvoiceBranchDetails,
    } = values;
    try {
      const body = JSON.stringify({
        salesOrder,
        indentNo,
        isFromHo,
        requiredDateAd,
        branch,
        status,
        discountAmount,
        grandTotal,
        voucherDateBs,
        voucherDate,
        // refVoucher,
        saleInvoiceBranchDetails,
      });
      const { data } = await API.updateSaleInvoiceBranch(id, body);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

// handle search
export const handleSearch = createAsyncThunk(
  "saleInvoiceBranch/handleSearch",
  async ({ rowsPerPage, search, sortOrder, pageNo }, { rejectWithValue }) => {
    try {
      const { data } = await API.handleSearch({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);
